import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * get term enteties
 * */
function* getTermEntities() {
    const response = yield call(api.getTermEntities);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_TERM_ENTITIES.SUCCESS,
            data: response.data,
        });
        return;
    }

    yield put({
        type: actionTypes.GET_TERM_ENTITIES.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetTermEntities() {
    while (true) {
        yield take(actionTypes.GET_TERM_ENTITIES.REQUEST);
        yield fork(getTermEntities);
    }
}

export default [
    watchGetTermEntities,
];



// WEBPACK FOOTER //
// ./app/sagas/termEntities.js